import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';

export type AiMode = 'daily_suggestion' | 'message_helper' | 'pet_voice';

export interface AiCompanionResponse {
  text: string;
  mode: AiMode;
  day: string;
  source: 'openai' | 'fallback';
  model: string;
  cached: boolean;
  usage?: {
    remainingCouple: number;
    remainingUser: number;
    remainingMode: number;
  };
}

const functions = getFunctions(app, 'europe-west1');
const aiCallable = httpsCallable(functions, 'aiCompanion');

export async function callAiCompanion(input: {
  mode: AiMode;
  message?: string;
  style?: string;
}) {
  const result = await aiCallable(input);
  return result.data as AiCompanionResponse;
}
